import * as R from 'ramda'
import mergeConfig from 'coact/config/mergeConfig'

import itemsViewConfig from './itemsClient.js'

const config = R.assocPath(['models', 'retailOrderItems'], itemsViewConfig, {})

export default fullConfig => mergeConfig(fullConfig, config)
